import { z } from 'zod';
import { zTranslatableBothRequired } from './translatable.js';
/** Admin "save service" payload. Mirrors Admin\ServicesController::save(). */
export const serviceSaveSchema = z.object({
    title: zTranslatableBothRequired,
    fullDescription: zTranslatableBothRequired,
    type: z.enum(['for-companies', 'for-candidates']),
    icon: z.string().max(255).nullable().optional(),
    imagePath: z.string().nullable().optional(),
});
export const serviceImageFileSchema = z.object({
    sizeKb: z.number().max(8096, 'Image must be <= 8096 KB'),
    type: z.enum(['image/jpeg', 'image/png', 'image/jpg', 'image/gif']),
});
//# sourceMappingURL=service.js.map